import React from 'react'
import { Filter } from '../../shared/ui/Filter'
import { Checkbox, Form, Input } from 'antd'
import { t } from '../../../config/i18n'
import { observer } from 'mobx-react'
import { AbstractCatalogService } from '../../../services/AbstractCatalogService'

const initialFilter: TObjectAny = { name: '', displayInWeb: null }

interface Props {
  catalogService: AbstractCatalogService<any, any>
}

export const PageCatalogItemListFilter = observer(({ catalogService }: Props) => {
  return (
    <Filter
      initialFilter={initialFilter}
      filter={catalogService.store.itemListFilter}
      onChange={filter => catalogService.setItemListFilter(filter)}
    >
      {(key, filter, onUpdate) => (
        <Form
          key={key}
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 14 }}
          initialValues={filter}
          autoComplete="off"
          onValuesChange={(_, filter) => onUpdate(filter)}
        >
          <Form.Item
            label={t.common.name}
            name="name"
          >
            <Input />
          </Form.Item>

          {catalogService.type === 'single' && (
            <Form.Item
              name="displayInWeb"
              label="displayInWeb"
              valuePropName="checked"
            >
              <Checkbox />
            </Form.Item>
          )}

          <Form.Item
            name="showInactive"
            label={t.catalog.showInactive}
            valuePropName="checked"
          >
            <Checkbox />
          </Form.Item>
        </Form>
      )}
    </Filter>
  )
})
